module.exports = __webpack_public_path__ + "static/img/aboutysj.9c77a3ce.png";